import ApiResourceManager from './ApiResourceManager';

export default class ConfigManager extends ApiResourceManager {
  update = (data) =>
    this.request({
      method: 'PUT',
      url: '/config',
      data,
    });
}
